
import { ExternalLink } from '@uikit/components/ExternalLink';

export const GateIoLink = () => (
  <ExternalLink
    className="text-primary-600 story-prose-none"
    href="https://www.gate.io/signup/AlBAU1Fd?ref_type=103"
  >
    Gate.io
  </ExternalLink>
);
